import { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { Modal, Spinner, ListGroup, Badge } from "react-bootstrap";

export default function HistoryModal({
  entityType,
  entityId,
  show,
  onHide,
  title = "History",
}) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show || !entityType || !entityId) return;

    let isCancelled = false;
    async function fetchEvents() {
      setLoading(true);
      setError(null);
      try {
        const { data, error } = await supabase
          .from("events")
          .select("*")
          .eq("entity_type", entityType)
          .eq("entity_id", entityId)
          .order("created_at", { ascending: false });

        if (error) throw error;
        if (!isCancelled) setEvents(data || []);
      } catch (err) {
        if (!isCancelled) {
          console.error("Error loading history:", err);
          setError(err.message || "Failed to load history");
        }
      } finally {
        if (!isCancelled) setLoading(false);
      }
    }

    fetchEvents();
    return () => {
      isCancelled = true;
    };
  }, [show, entityType, entityId]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="text-center my-3">
            <Spinner animation="border" size="sm" /> Loading history...
          </div>
        )}
        {error && (
          <div className="text-danger small mb-2">
            {error}
          </div>
        )}
        {!loading && !error && events.length === 0 && (
          <div className="text-muted small">
            No history events recorded yet.
          </div>
        )}
        {!loading && events.length > 0 && (
          <ListGroup variant="flush">
            {events.map((ev) => (
              <ListGroup.Item key={ev.id} className="px-0">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="me-3">
                    <div className="small fw-bold">
                      {ev.summary}
                    </div>
                    {ev.details && (
                      <pre className="small bg-light border rounded p-2 mt-1 mb-0">
                        {JSON.stringify(ev.details, null, 2)}
                      </pre>
                    )}
                  </div>
                  <div className="text-end small text-muted">
                    <div>
                      {new Date(ev.created_at).toLocaleString()}
                    </div>
                    {ev.actor_name && (
                      <div>
                        <Badge bg="light" text="dark">
                          {ev.actor_name}
                        </Badge>
                      </div>
                    )}
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
    </Modal>
  );
}

